import axios from '@/libs/api.request'

export const getPartSubstituteCollections = (partId) => {
  return axios.request({
    url: `/parts/${partId}/substitute/all`,
    method: 'get'
  })
}

export const addPartToSubstituteCollection = (substituteType, substituteId, partId) => {
  return axios.request({
    url: `/parts/substitute/${substituteType}/${substituteId}/items`,
    method: 'post',
    data: { component_id: partId }
  })
}

export const removeItemFromSubstituteCollection = (substituteType, itemId) => {
  return axios.request({
    url: `/parts/substitute/${substituteType}/items/${itemId}`,
    method: 'delete'
  })
}

export const createSubstituteCollection = (description, substituteType, basePartId, specification = '', partIds = null, partCategoryId = null) => {
  return axios.request({
    url: `/parts/substitute/${substituteType}`,
    method: 'post',
    data: {
      description: description,
      substitution_type: substituteType,
      component_ids: partIds,
      base_manufacturer_part_id: basePartId,
      specs: specification,
      part_category_id: partCategoryId
    }
  })
}

export const mergeSubstituteCollections = (substituteType, primarySubstituteId, secondarySubstituteId) => {
  return axios.request({
    url: `/parts/substitute/${substituteType}/merge`,
    method: 'post',
    data: { primary_substitute_id: primarySubstituteId, secondary_substitute_id: secondarySubstituteId }
  })
}

export const getCertainSubstituteByPart = (substituteType, partId) => {
  return axios.request({
    url: `/parts/${partId}/substitute/${substituteType}`,
    method: 'get',
    data: { substitute_type: substituteType, part_id: partId }
  })
}
